import { Captions, Maximize, Minimize, Pause, Play, Repeat, StepBack, StepForward, Volume2, VolumeX } from 'lucide-react';
import Button from './Button';
import ScrubBar from './ScrubBar';
import Timecode from './Timecode';

const SPEEDS = [0.5, 1, 1.5, 2];

// §2.6 Transport: the scrub bar along the bottom edge of the stage, then
// play · frame step · loop · speed · volume · timecode / duration · captions · quality · full screen.
// A control renders only when its handler is passed — nothing on the bar is dead.
// onFrameStep(-1 | 1) steps one frame back / forward (HD-8 review). fullscreen = true swaps the control to "Exit full screen".
export default function Transport({
  time, duration, playing, onPlayPause, onSeek, markers, activeMarker, onMarker, ticks, format = 'mss', fps,
  loop, onLoop, speed = 1, onSpeed, muted, onMute, captions, onCaptions, quality, onQuality, onFullscreen, fullscreen = false, onFrameStep,
}) {
  return (
    <div className="ui ui-transport">
      <ScrubBar duration={duration} position={time} onSeek={onSeek} markers={markers} activeMarker={activeMarker} onMarker={onMarker} ticks={ticks} format={format} fps={fps} />
      <div className="ui-transport__bar">
        {onPlayPause && <Button variant="quiet" iconOnly icon={playing ? Pause : Play} label={playing ? 'Pause' : 'Play'} onClick={onPlayPause} />}
        {onFrameStep && <Button variant="quiet" iconOnly icon={StepBack} label="Previous frame" onClick={() => onFrameStep(-1)} />}
        {onFrameStep && <Button variant="quiet" iconOnly icon={StepForward} label="Next frame" onClick={() => onFrameStep(1)} />}
        {onLoop && <Button variant="quiet" iconOnly icon={Repeat} label={loop ? 'Loop on' : 'Loop off'} aria-pressed={!!loop} onClick={onLoop} />}
        {onSpeed && <Button variant="quiet" className="ui-transport__speed" aria-label={`Speed ${speed}x, change`} onClick={() => onSpeed(SPEEDS[(SPEEDS.indexOf(speed) + 1) % SPEEDS.length])}>{speed}x</Button>}
        {onMute && <Button variant="quiet" iconOnly icon={muted ? VolumeX : Volume2} label={muted ? 'Unmute' : 'Mute'} onClick={onMute} />}
        <span className="ui-transport__time"><Timecode seconds={time} format={format} fps={fps} /><span className="ui-meta">/</span><Timecode seconds={duration} format={format} fps={fps} /></span>
        <span className="ui-transport__spacer" />
        {onCaptions && <Button variant="quiet" iconOnly icon={Captions} label={captions ? 'Captions on' : 'Captions off'} aria-pressed={!!captions} onClick={onCaptions} />}
        {onQuality && <Button variant="quiet" onClick={onQuality} aria-label={`Quality ${quality}, change`}>{quality}</Button>}
        {onFullscreen && <Button variant="quiet" iconOnly icon={fullscreen ? Minimize : Maximize} label={fullscreen ? 'Exit full screen' : 'Full screen'} onClick={onFullscreen} />}
      </div>
    </div>
  );
}
